// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"68":"c9071b97","226":"254db8fe","520":"f5bfcdce"}[chunkId] + ".chunk.css");